import { arrayMove } from '@dnd-kit/sortable';
import type { NavigationMenuChildLink } from '../../../schemas/validation';

export function sortSubLinks(children: NavigationMenuChildLink[]): NavigationMenuChildLink[] {
  return [...children].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

/** Id used by the sortable list. Falls back to menu position when a child has no id. */
export function subLinkDragId(child: NavigationMenuChildLink, index: number): string {
  return child.id || `sub-link-${index}`;
}

function createChildId(): string {
  return `child-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

/**
 * Move a submenu link and rewrite `order` to 0, 1, 2… in the new sequence.
 * Returns the same array when the drop does not change the list.
 */
export function reorderSubLinks(
  children: NavigationMenuChildLink[],
  activeId: string,
  overId: string | null | undefined
): NavigationMenuChildLink[] {
  if (!overId || activeId === overId) return children;

  const sorted = sortSubLinks(children);
  const ids = sorted.map((child, index) => subLinkDragId(child, index));
  const oldIndex = ids.indexOf(activeId);
  const newIndex = ids.indexOf(overId);
  if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) return children;

  return arrayMove(sorted, oldIndex, newIndex).map((child, index) => ({
    ...child,
    id: child.id ?? createChildId(),
    order: index,
  }));
}
